module.exports = __webpack_public_path__ + "img/reinsurance-v2.b86b456d.png";